export const adaptiveBatchIntervalPolicy = {
  baseIntervalMs: 200,
  maxIntervalMs: 5000,
  baseIntervalClientCount: 40,
  maxIntervalClientCount: 300,
} as const;

/**
 * Broadcast fan-out grows approximately with the square of the collaborator count.
 */
export function getAdaptiveBatchIntervalMs(clientCount: number): number {
  const {
    baseIntervalMs,
    maxIntervalMs,
    baseIntervalClientCount,
    maxIntervalClientCount,
  } = adaptiveBatchIntervalPolicy;
  const progress = Math.min(
    1,
    Math.max(
      0,
      (clientCount ** 2 - baseIntervalClientCount ** 2) /
        (maxIntervalClientCount ** 2 - baseIntervalClientCount ** 2),
    ),
  );
  return baseIntervalMs + progress * (maxIntervalMs - baseIntervalMs);
}
